module.exports = __webpack_public_path__ + "static/media/CS174A.6bc130ec.PNG";